
import { Outlet, Link, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

import { CreditLogProvider } from 'contexts/credit_log_context';
import { PaymentProvider } from 'contexts/payment_context';
import useRoles from 'hooks/useRoles';
import useUserIdentity from 'hooks/useUserIdentity';


const SupportContainer = observer(() => {

    const location = useLocation();
    const { currentIdentity } = useUserIdentity();
    const { rolesNames } = useRoles();

    const URL = ['/support', '/support/create'].includes(location.pathname) ?
        '/support' : '/support/dashboard';

    const inAdmin = URL === '/support/dashboard';

    const isSupport = rolesNames.includes('support') &&
        currentIdentity.role == 'assistant';

    /* Keep in mind, both assistants and clients need support */

    return (
        <CreditLogProvider>
            <PaymentProvider>
                <Stack>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        borderBottom={1}
                        borderColor="divider"
                        sx={{
                                width: { xs: '100%' },
                                borderBottom: 1,
                            }}
                        p={1}
                    >
                        { !inAdmin && isSupport && (
                            <Link to="/support/dashboard">
                                <Typography
                                    color="primary"
                                    level="title-sm">Support Dashboard</Typography>
                            </Link>
                        )}
                    </Stack>

                    <Stack p={1}>
                        <Outlet />
                    </Stack>

                </Stack>
            </PaymentProvider>
        </CreditLogProvider>
    );

});



export default SupportContainer;
